import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import { initVuetify } from './plugins/vuetify';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import i18n from './i18n';
import AppInit from './plugins/appinit';
import '@/filters/filters';
import '@/styles/main.scss';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import VueAnalytics from 'vue-analytics';
import { actions } from '@/models/store.actions';
import DefaultHub from '@/plugins/signalR';
import { EventBus } from '@/helpers/event-bus';
import dialogs from './plugins/dialogs';
import '@/directives/inputMask';
import './plugins/cordova';
import Logger from '@/helpers/log.service';
import { isNativeApp } from '@/helpers/platform-helper';

goBackIfRequired();

Vue.config.productionTip = false;

Vue.use(AppInit);

Vue.use(Donut);

Vue.prototype.$eventBus = EventBus;

Vue.use(DefaultHub, { store, actions, router });

Vue.use(Logger);

(async function() {
  try {
    store.dispatch(actions.SETT_ACT_CONFIG);

    try {
      await store.dispatch(actions.SETT_ACT_APPSET);
    } catch (error) {
      await handleConfigLoadingError(error);
    }

    const appSett = store.getters[actions.SETT_GET_APPSET];

    const vuetify = initVuetify(appSett);

    Vue.use(dialogs, { vuetify });

    if (appSett && appSett.googleAnalyticsEnabled) {
      Vue.use(VueAnalytics, {
        id: appSett.googleAnalyticsKey,
        router
      });
    }

    new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: h => h(App),
      created: () => EventBus.$emit('app-created')
    }).$mount('#app');
  } catch (error) {
    alert(`Error\n${(error as any).message}`);
  }
})();

async function handleConfigLoadingError(err) {
  if (isNativeApp() && err && err.message && err.message.indexOf('<!DOCTYPE HTML>') > -1 && err.message.indexOf('Ray ID') > -1) {
    try {
      let cfg = await store.getters[actions.SETT_GET_CFG_WAITER];

      const storageKey = 'native_app_cloudflare_handling_counter';
      let cloudFlareCounting = Number(sessionStorage.getItem(storageKey));
      if (isNaN(cloudFlareCounting)) cloudFlareCounting = 0;

      if (cloudFlareCounting === 0 && cfg && !!cfg.apiHost) {
        cloudFlareCounting += 1;
        sessionStorage.setItem(storageKey, `${cloudFlareCounting}`);
        window.location.href = `${cfg.apiHost}?gb=1`;
      } else {
        throw err;
      }
    } catch {
      throw err;
    }
  } else {
    throw err;
  }
}

function goBackIfRequired() {
  try {
    if (isNativeApp()) return;

    const search = window.location.search.substring(1);
    if (!search) return;

    let queryParamsArr = search.split('&');
    if (queryParamsArr.length === 0) return;

    let goBackParamFound = false;
    for (let p of queryParamsArr) {
      let paramArr = p.split('=');
      if (paramArr.length > 1 && paramArr[0] === 'gb' && paramArr[1] === '1') {
        goBackParamFound = true;
        break;
      }
    }

    if (goBackParamFound && history.length > 1) {
      history.go((history.length - 1) * -1);
    }
  } catch {
    // ignored
  }
}
